import { NavigateFunction } from 'react-router-dom';

const resolvers: Record<string, (value: any) => void> = {};

const setPopResult = (state: any, value: any) => {
	const intentId = state?.intentId;
	const resolver = intentId && resolvers[intentId];
	if (!resolver) {
		return;
	}

	resolver(value);
};

export const pushWithResult = <T = any>(navigate: NavigateFunction, to: string): Promise<T> => {
	const intentId = Math.random().toString(36).substring(2, 15);
	navigate(to, { state: { intentId } });

	return new Promise((resolve) => (resolvers[intentId] = resolve));
};

export const popWithResult = <T = any>(navigate: NavigateFunction, state: any, value: T) => {
	setPopResult(state, value);
	navigate(-1);
};
